export default __webpack_public_path__ + "static/media/mint.52ddad96.png";